<div class="flex flex-col w-32 shadow rounded-xl bg-card">
  <div class="aspect-w-9 aspect-h-6">
    <div class="flex items-center justify-center">
      <!-- Label tipo arquivo -->
      <div class="relative" *ngIf="!isImg">
        <mat-icon
          class="icon-size-14 text-hint"
          [svgIcon]="'heroicons_outline:document'"
        ></mat-icon>
        <div
          class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white bg-gray-500"
          [class.bg-red-600]="type === 'PDF'"
          [class.bg-blue-600]="type === 'DOC'"
          [class.bg-blue-600]="type === 'DOCX'"
          [class.bg-green-600]="type === 'XLS'"
          [class.bg-gray-600]="type === 'TXT'"
          [class.bg-amber-600]="type === 'JPG'"
          [class.bg-amber-600]="type === 'JPEG'"
          [class.bg-amber-600]="type === 'PNG'"
          [class.bg-blue-600]="type === 'ZIP'"
          [class.bg-blue-600]="type === 'SVG'"
          [class.bg-blue-600]="type === 'P7S'"
        >
          {{ type.toUpperCase() }}
        </div>
      </div>

      <div class="flex justify-center" *ngIf="isImg">
        <img class="h-20 w-20 object-cover" [src]="file.url" [alt]="file.nome">
      </div>

      <!--Btn delete-->
      <button
        *ngIf="isEditMod"
        mat-icon-button
        color="warn"
        (click)="handleTeleteFile()"
        class="absolute -top-4 -right-5"
      >
        <mat-icon> delete </mat-icon>
      </button>
    </div>
  </div>

  <!-- Título -->
  <div
    class="flex flex-col flex-auto justify-center text-center text-sm font-medium"
  >
    <div class="truncate" [matTooltip]="file.nome" matTooltipPosition="above">
      {{ file.nome }}
    </div>
  </div>

  <div class="flex m-2 gap-1">
    <a
      [href]="file.url"
      target="_blank"
      class="w-full cursor-pointer rounded-full  flex items-center justify-center"
      [ngClass]="colorButton ? colorButton : {'bg-blue-600': true}"
    >
      <mat-icon
        svgIcon="heroicons_outline:download"
        class="text-white py-1"
      ></mat-icon>
    </a>
    <a
      [href]="assinatura.url"
      target="_blank"
      *ngIf="assinatura"
      class="w-full cursor-pointer rounded-full bg-green-600 flex items-center justify-center"
    >
      <mat-icon
        svgIcon="heroicons_outline:pencil-alt"
        class="text-white py-1"
      ></mat-icon>
    </a>
  </div>
</div>
